import axios from "axios";
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";

import { GET_ERRORS, SET_CURRENT_USER, USER_LOADING } from "./types";
import { Store } from "react-notifications-component";

const DEFAULT_LOGIN_ERROR = "Email ou mot de passe incorrect";

const normalizeLoginErrors = (errorData = {}) => {
  const apiErrors = errorData.errors || {};
  const hasFieldErrors = Object.keys(apiErrors).length > 0;
  const message =
    errorData.message ||
    apiErrors.message ||
    apiErrors.email ||
    apiErrors.password ||
    DEFAULT_LOGIN_ERROR;

  if (hasFieldErrors) {
    return {
      message,
      ...apiErrors
    };
  }

  return {
    message,
    email: message,
    password: message
  };
};

const getLoginErrorMessage = (errors = {}) =>
  errors.message || errors.email || errors.password || DEFAULT_LOGIN_ERROR;

// Register User
export const registerUser = (userData, history) => dispatch => {
  axios
    .post("/api/users/register", userData)
    .then(res => history.push("/login"))
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Login - get user token
export const loginUser = (userData, history) => dispatch => {
  dispatch(setUserLoading());
  
  axios
    .post("/api/auth/login", userData)
    .then(res => {
      // Save to localStorage
      const { token, user } = res.data;
      
      // Stocker le token complet (avec "Bearer ")
      localStorage.setItem("jwtToken", token);
      
      // Set token to Auth header
      setAuthToken(token);
      
      // Set current user avec les données complètes
      dispatch(setCurrentUser(user));
      
      // Rediriger vers le dashboard
      if (history) {
        history.push("/dashboard");
      }
      
      // Notification de succès
      Store.addNotification({
        title: "Connexion réussie",
        message: `Bienvenue ${user.name || user.email} !`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
    })
    .catch(err => {
      const errorData = err.response?.data || { 
        error: true, 
        message: "Erreur lors de la connexion" 
      };
      const loginErrors = normalizeLoginErrors(errorData);
      
      dispatch({
        type: GET_ERRORS,
        payload: loginErrors
      });

      Store.addNotification({
        title: "Erreur de connexion",
        message: getLoginErrorMessage(loginErrors),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    });
};

// Set logged in user
export const setCurrentUser = user => {
  return {
    type: SET_CURRENT_USER,
    payload: user
  };
};

// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from local storage
  localStorage.removeItem("jwtToken");
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to empty object {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
  
  // Notification de déconnexion
  Store.addNotification({
    title: "Déconnexion réussie",
    message: "Vous avez été déconnecté avec succès",
    type: "success",
    insert: "top",
    container: "top-right",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    dismiss: {
      duration: 3000,
      onScreen: true
    }
  });
};

export const takeContact = (info, callback) => dispatch => {
  axios
    .post("/api/contact", info)
    .then(res => {
      if (res.data) {

        Store.addNotification({
          title: "'Message envoyée'",
          message: res.data.message,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 10 * 1000,
            onScreen: true
          }
        });

        // if (callback) return callback(false, res.data);
      }
    })
    .catch(err => {
        if (err.response) {
          dispatch({
            type: GET_ERRORS,
            payload: err.response.data
          });
          // if (callback) return callback(err, err.response.data);
        }
      }
    );
};
